import React, { useState } from 'react';
import { TextField, MenuItem, Select } from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useSelector } from 'react-redux';
import { format, addDays } from 'date-fns';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { COWORKING, MEETING_ROOM } from '@/types/spaceTypes.constants';
import {
  countryOptions,
  calculateHoursDifference,
  formatDateToWords,
  formatDateToEnglishWords,
  hoursToSelect,
} from '@/helpers/dateHelpers';
import { Formik, Form, Field } from 'formik';
import { validationSchema } from '../Validations/ValidationReservationSchema';
import dayjs from 'dayjs';
import Label from '@/components/form/Label/Label';

require('dayjs/locale/es');
dayjs.locale('es');

const GuestDataForm = (props) => {
  const { onSubmitFunction, spaceDetail, lenguage, backButton } = props;
  const [showEditFormData, setShowEditFormData] = useState(false);
  const searchFormData = useSelector((state) => state.searchFormData);
  const tomorrow = format(addDays(new Date(), 1), 'yyyy-MM-dd');

  return (
    <Formik
      initialValues={{
        startDate: searchFormData?.startDate ? searchFormData?.startDate : tomorrow,
        startTime: searchFormData?.startTime ? searchFormData?.startTime : '09:00',
        endTime: searchFormData?.endTime ? searchFormData?.endTime : '10:00',
        guestQuantyty: searchFormData?.guests ? searchFormData?.guests : 1,
        spaceType: spaceDetail?.subtype_id,
        name: '',
        email: '',
        phone: '',
        countryCode: lenguage === 'EN' ? '+1' : '+52',
      }}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        onSubmitFunction(values, spaceDetail);
      }}
    >
      {({ setFieldValue, values, isValid, dirty, errors, touched }) => {
        const hours = calculateHoursDifference(values?.startTime, values?.endTime);

        const totalPrice = () => {
          const price = parseFloat(spaceDetail?.calculatedPrice || '0');
          let total;
          if (spaceDetail?.subtype_id === COWORKING) {
            total = price * (values?.guestQuantyty || 1);
          } else {
            total = price * (hours > 0 ? hours : 0);
          }
          return parseFloat(total.toFixed(2));
        };

        const dayLabel = lenguage === 'EN' ? ' day' : ' día';
        const hourLabel = lenguage === 'EN' ? ' hour' : ' hora';
        const timeLabel = spaceDetail?.subtype_id === COWORKING ? dayLabel : hourLabel;
        const peopleLabelEn = values?.guestQuantyty === 1 ? ' Person' : ' People';
        const peopleLabelEs = values?.guestQuantyty === 1 ? ' Personas' : ' Persona';
        const guestLabel =
          lenguage === 'EN'
            ? 'People: ' + values?.guestQuantyty + peopleLabelEn
            : 'Personas: ' + values?.guestQuantyty + peopleLabelEs;
        const dateLabel =
          lenguage === 'EN'
            ? 'Date: ' + formatDateToEnglishWords(values?.startDate)
            : 'Fecha: ' + formatDateToWords(values?.startDate);
        const startTime =
          lenguage === 'EN'
            ? 'Start time: ' + values?.startTime + ' hours'
            : 'Hora de inicio: ' + values?.startTime + ' horas';
        const endTime =
          lenguage === 'EN'
            ? 'End Time: ' + values?.endTime + ' hours'
            : 'Hora de Fin: ' + values?.endTime + ' horas';

        return (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Form className={'flex-container flex-column'}>
              <FlexContainer className={'gap-20 m-flex-column'}>
                <FlexContainer className={'flex-column gap-20 width100'}>
                  <label className={'text-22 m-text-20 fontPink1'}>
                    {' '}
                    <strong>
                      {lenguage === 'EN' ? 'Reservation details' : 'Datos de la reserva'}
                    </strong>
                  </label>
                  {!showEditFormData && (
                    <>
                      <FlexContainer
                        className={
                          'flex-column gap-20 padlr20 padtb10 grayShadowBottom border-rad16px borderGray100'
                        }
                      >
                        <FlexContainer className={'justify-between'}>
                          <label className={'text-16 m-text-14 '}>{guestLabel} </label>
                          <button
                            type="button"
                            onClick={() => setShowEditFormData(true)}
                            className={'bgWhite fontGray250 borderNone padlr10 padtb4 text-12'}
                          >
                            {lenguage === 'ES' ? 'Editar' : 'Edit'} <i className="fa fa-pencil" />
                          </button>
                        </FlexContainer>
                        <FlexContainer className={'justify-between'}>
                          <label className={'text-16 m-text-14 '}>{dateLabel} </label>
                          <button
                            type="button"
                            onClick={() => setShowEditFormData(true)}
                            className={'bgWhite fontGray250 borderNone padlr10 padtb4 text-12'}
                          >
                            {lenguage === 'ES' ? 'Editar' : 'Edit'} <i className="fa fa-pencil" />
                          </button>
                        </FlexContainer>
                        <FlexContainer className={'justify-between'}>
                          <label className={'text-16 m-text-14 '}>{startTime} </label>
                          <button
                            type="button"
                            onClick={() => setShowEditFormData(true)}
                            className={'bgWhite fontGray250 borderNone padlr10 padtb4 text-12'}
                          >
                            {lenguage === 'ES' ? 'Editar' : 'Edit'} <i className="fa fa-pencil" />
                          </button>
                        </FlexContainer>
                        <FlexContainer className={'justify-between'}>
                          <label className={'text-16 m-text-14 '}>{endTime} </label>
                          <button
                            type="button"
                            onClick={() => setShowEditFormData(true)}
                            className={'bgWhite fontGray250 borderNone padlr10 padtb4 text-12'}
                          >
                            {lenguage === 'ES' ? 'Editar' : 'Edit'} <i className="fa fa-pencil" />
                          </button>
                        </FlexContainer>

                        <label className={'text-18 m-text-20 margtb10'}>
                          <strong>
                            {lenguage === 'ES' ? 'Información del precio' : 'Price Information'}
                          </strong>
                        </label>
                        <FlexContainer className={'justify-between gap-20'}>
                          <label className={'text-16 m-text-14 '}>
                            {' '}
                            {lenguage === 'ES' ? 'Precio por ' : 'Price per '} {timeLabel}:
                          </label>
                          <label className={'text-16 m-text-14 '}>
                            <strong>${spaceDetail?.formattedPrice} </strong>
                          </label>
                        </FlexContainer>
                        {spaceDetail?.subtype_id !== 1 && (
                          <FlexContainer className={'justify-between'}>
                            <label className={'text-16 m-text-14 '}>
                              {' '}
                              {lenguage === 'ES' ? 'Tiempo:' : 'Time'}
                            </label>
                            {lenguage === 'EN' && (
                              <label className={'text-16 m-text-14 '}>
                                <strong>
                                  {hours}
                                  {hours === 1 ? ' hour' : ' hours'}{' '}
                                </strong>
                              </label>
                            )}
                            {lenguage === 'ES' && (
                              <label className={'text-16 m-text-14 '}>
                                <strong>
                                  {hours}
                                  {hours === 1 ? ' hora' : ' horas'}{' '}
                                </strong>
                              </label>
                            )}
                          </FlexContainer>
                        )}
                        {spaceDetail?.subtype_id === COWORKING && (
                          <FlexContainer className={'justify-between'}>
                            <label className={'text-16 m-text-14 '}>
                              {lenguage === 'ES' ? 'Cantidad de personas:' : 'Number of People:'}
                            </label>

                            <label className={'text-16 m-text-14 '}>
                              {values?.guestQuantyty > 1 && (
                                <strong>
                                  {values?.guestQuantyty}
                                  {lenguage === 'ES' ? ' personas' : ' seats'}{' '}
                                </strong>
                              )}
                              {values?.guestQuantyty == 1 && (
                                <strong>
                                  {'x'}
                                  {values?.guestQuantyty}
                                  {lenguage === 'ES' ? ' persona' : ' seat'}{' '}
                                </strong>
                              )}
                            </label>
                          </FlexContainer>
                        )}
                        {spaceDetail?.subtype_id === COWORKING && (
                          <FlexContainer className={'text-12'}>
                            {lenguage === 'ES'
                              ? 'El precio de renta de un pase de coworking no se calculará en función a la cantidad de horas seleccionadas, la reserva puede hacerse efectiva a lo largo del día seleccionado.'
                              : 'The rental price of a coworking pass will not be calculated based on the number of selected hours; the reservation can be used at any time throughout the selected day.'}
                          </FlexContainer>
                        )}
                        {spaceDetail?.subtype_id !== 1 && (
                          <FlexContainer className={'text-12'}>
                            {lenguage === 'ES'
                              ? 'El precio de renta de una sala de juntas o terraza se calculará en función a la cantidad de horas seleccionadas.'
                              : 'The rental price is calculated based on the number of hours selected.'}
                          </FlexContainer>
                        )}
                      </FlexContainer>
                    </>
                  )}
                  {showEditFormData && (
                    <>
                      <Field name="startDate">
                        {({ field, form }) => (
                          <DatePicker
                            label={lenguage === 'ES'? "Fecha de inicio de reservación" : "Start Date"}
                            value={values?.startDate ? dayjs(values?.startDate) : null}
                            minDate={dayjs()}
                            onChange={(newValue) => {
                              setFieldValue(
                                'startDate',
                                newValue ? dayjs(newValue).format('YYYY-MM-DD') : '',
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={Boolean(form.errors.startDate && form.touched.startDate)}
                                helperText={form.touched.startDate && form.errors.startDate}
                              />
                            )}
                          />
                        )}
                      </Field>
                      <Field name="guestQuantyty">
                        {({ field, form }) => (
                          <TextField
                            {...field}
                            label={lenguage === 'ES'? "Número de Personas" : "Quest Quantyty"}
                            variant="outlined"
                            type="number"
                            onChange={(e) => setFieldValue('guestQuantyty', e.target.value)}
                            error={Boolean(form.errors.guestQuantyty && form.touched.guestQuantyty)}
                            helperText={form.touched.guestQuantyty && form.errors.guestQuantyty}
                          />
                        )}
                      </Field>
                      <Field name="startTime">
                        {({ field, form }) => (
                          <div>
                            <TextField
                              select
                              fullWidth
                              label={lenguage === 'ES' ? 'Hora de entrada' : 'Check-in Time'}
                              variant="outlined"
                              value={form.values?.startTime}
                              onChange={(e) => {
                                setFieldValue('startTime', e.target.value);
                                if (
                                  form.values?.endTime &&
                                  e.target.value >= form.values?.endTime
                                ) {
                                  setFieldValue('endTime', '');
                                }
                              }}
                              error={touched.startTime && Boolean(errors.startTime)}
                              helperText={touched.startTime && errors.startTime}
                            >
                              {hoursToSelect.map((hour) => (
                                <MenuItem key={hour} value={hour}>
                                  {hour}
                                </MenuItem>
                              ))}
                            </TextField>
                            {form.errors.startTime && form.touched.startTime && (
                              <div className="text-red-600">{form.errors.startTime}</div>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="endTime">
                        {({ field, form }) => (
                          <div>
                            <TextField
                              select
                              fullWidth
                              label={lenguage === 'ES' ? 'Hora de Salida' : 'Check-out Time'}
                              variant="outlined"
                              value={form.values?.endTime}
                              onChange={(e) => setFieldValue('endTime', e.target.value)}
                              error={touched.endTime && Boolean(errors.endTime)}
                              helperText={touched.endTime && errors.endTime}
                            >
                              {hoursToSelect
                                .filter((hour) => {
                                  if (!form.values?.startTime) return true;
                                  const [startHour, startMinutes] = form.values?.startTime
                                    .split(':')
                                    .map(Number);
                                  const [endHour, endMinutes] = hour.split(':').map(Number);
                                  return (
                                    endHour * 60 + endMinutes >= startHour * 60 + startMinutes + 60
                                  );
                                })
                                .map((hour) => (
                                  <MenuItem key={hour} value={hour}>
                                    {hour}
                                  </MenuItem>
                                ))}
                            </TextField>
                            {form.errors.endTime && form.touched.endTime && (
                              <div className="text-red-600">{form.errors.endTime}</div>
                            )}
                          </div>
                        )}
                      </Field>
                      <button
                        type="button"
                        onClick={() => setShowEditFormData(false)}
                        className={
                          'bgWhite fontGray250 width100 bold border-rad8px borderGray050 grayShadow16 margtb10 padlr40 padtb20 text-12'
                        }
                      >
                        {lenguage === 'ES' ? 'Terminar de editar' : 'Finish editing'}{' '}
                        <i className="fa fa-pencil" />
                      </button>
                    </>
                  )}
                  <FlexContainer
                    className={
                      'justify-between borderGray100 justify-between padlr10 padtb10 margt20'
                    }
                  >
                    <label className={'text-16 m-text-14'}>
                      <strong>TOTAL</strong>
                    </label>
                    <label>
                      <strong className={'text-20 m-text-18'}>
                        ${totalPrice() + ' ' + spaceDetail?.currency}
                      </strong>
                    </label>
                  </FlexContainer>
                </FlexContainer>
                <FlexContainer
                  className={
                    'flex-column format100 m-formatAuto gap-10 padlr20 padtb10 grayShadowBottom border-rad16px borderGray100'
                  }
                >
                  <FlexContainer className={'gap-8 text-12 align-center margt10 align-self-end'}>
                    <button
                      type="button"
                      className={
                        'bgGray050 border-rad4px padlr20 padtb6 borderGray050 fontGray500 text-16'
                      }
                      onClick={() => backButton()}
                    >
                      <i className={'fa fa-arrow-left margr6'} aria-hidden="true" />
                      {lenguage === 'EN' ? 'Back' : 'Atrás'}
                    </button>
                  </FlexContainer>
                  <label className={'text-18 m-text-20 margt20'}>
                    <strong>
                      {lenguage === 'ES' ? 'Introduce tus datos' : 'Enter your details'}
                    </strong>
                  </label>
                  <FlexContainer className={'flex-column gap-10'}>
                    <FlexContainer className={'gap-10'}>
                      <FlexContainer className={'flex-column width100 gap-10'}>
                        <Field name="name">
                          {({ field, form }) => (
                            <TextField
                              {...field}
                              label={lenguage === 'EN' ? 'Name' : 'Nombre'}
                              variant="outlined"
                              error={Boolean(form.errors.name && form.touched.name)}
                              helperText={form.touched.name && form.errors.name}
                            />
                          )}
                        </Field>
                        <Field name="email">
                          {({ field, form }) => (
                            <TextField
                              {...field}
                              label="Email"
                              variant="outlined"
                              error={Boolean(form.errors.email && form.touched.email)}
                              helperText={form.touched.email && form.errors.email}
                            />
                          )}
                        </Field>
                      </FlexContainer>
                      <FlexContainer className={'flex-column width100 gap-10'}>
                        <Field name="countryCode">
                          {({ field }) => (
                            <Select
                              {...field}
                              label={lenguage === 'EN' ? 'Country code' : 'Código de país'}
                              variant="outlined"
                              onChange={(e) => setFieldValue('countryCode', e.target.value)}
                            >
                              {countryOptions.map((option) => (
                                <MenuItem key={option.code} value={option.code}>
                                  {option.code} ({option.country})
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        </Field>
                        <Field name="phone">
                          {({ field, form }) => (
                            <TextField
                              {...field}
                              label={lenguage === 'EN' ? 'Phone' : 'Teléfono'}
                              variant="outlined"
                              error={Boolean(form.errors.phone && form.touched.phone)}
                              helperText={form.touched.phone && form.errors.phone}
                            />
                          )}
                        </Field>
                      </FlexContainer>
                    </FlexContainer>
                    <button
                      type="submit"
                      className={
                        'bgPink1 width100 border-rad8px borderGray050 fontWhite grayShadow16 margtb30 padlr40 padtb10 text-18 pointer'
                      }
                      disabled={!isValid || !dirty}
                    >
                      <strong>{lenguage === 'ES' ? 'Pagar' : 'Pay'} </strong>
                    </button>
                  </FlexContainer>
                  {!isValid && dirty && (
                    <Label type="Subtitle-1" className={'fontRed100 margb10 text-10 text-center'}>
                      {lenguage === 'ES'
                        ? 'Por favor, revisa los campos. Algunos contienen errores o están incompletos.'
                        : 'Please check the fields. Some contain errors or are incomplete.'}
                    </Label>
                  )}
                </FlexContainer>
              </FlexContainer>
            </Form>
          </LocalizationProvider>
        );
      }}
    </Formik>
  );
};

const ReservationFormView = (props) => {
  const { className, onSubmitFunction, spaceDetail, backButton } = props;
  const lenguage = useSelector((state) => state.lenguage?.lang);
  const containerClass = className + ' flex-column';
  return (
    <FlexContainer className={containerClass}>
      <GuestDataForm
        onSubmitFunction={onSubmitFunction}
        spaceDetail={spaceDetail}
        lenguage={lenguage}
        backButton={backButton}
      />
    </FlexContainer>
  );
};

export default ReservationFormView;
